import {
  ProductCarousel as SharedProductCarousel,
  type ProductCarouselItem,
} from 'components/shared/ProductCarousel';

export type { ProductCarouselItem };

export type ProductCarouselProps = {
  items: ProductCarouselItem[];
  sticky?: boolean;
  navigationType?: 'buttons' | 'cursorTracked' | 'none';
  buttonVariant?: 'dark' | 'light' | 'glass';
  autoSlideDuration?: number;
  pauseOnHover?: boolean;
};

export const ProductCarousel = ({
  items,
  sticky = true,
  navigationType = 'cursorTracked',
  buttonVariant,
  autoSlideDuration = 4.2,
  pauseOnHover,
}: ProductCarouselProps) => {
  return (
    <SharedProductCarousel
      items={items}
      sticky={sticky}
      navigationType={navigationType}
      buttonVariant={buttonVariant}
      autoSlideDuration={autoSlideDuration}
      pauseOnHover={pauseOnHover}
    />
  );
};
